// extracted by mini-css-extract-plugin
export default {"content":"style_content__eX4Wi","footer":"style_footer__gyqsb","title":"style_title__MmaY2","pdf":"style_pdf__W9uWQ"};